import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalOverviewComponent } from '../../common/modal-overview/modal-overview.component';
import { Router } from '@angular/router';
import { PfepService } from '../../services/pfepService';
import { NoubaTableData } from '../../models/pfepModels';
import { environment } from '../../../environments/environment';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { NgxSpinnerService } from 'ngx-spinner';
import { PfepHistoryComponent } from '../../common/pfep-history/pfep-history.component';
import { AddRackNoubaPopupComponent } from '../../common/add-rack-nouba-popup/add-rack-nouba-popup.component';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'app-nouba-upload',
  templateUrl: './nouba-upload.component.html',
  styleUrls: ['./nouba-upload.component.scss']
})
export class NoubaUploadComponent implements OnInit {
  displayedColumns = ['select', 'noubaCode', 'drivingDirection', 'x', 'y', 'depth', 'width', 'building', 'history', 'delete'];
  dataSource = new MatTableDataSource<NoubaTableData>();
  selection = new SelectionModel<NoubaTableData>(true, []);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('noubaPage') noubaPage: ElementRef;
  @ViewChild('noubaInput') noubaInput: ElementRef;
  file: File = null;
  removable = true;
  buildings = new FormControl([]);
  buildingsArr = [];
  buildingArrLength:number = 0;
  noubaCode = new FormControl('', [Validators.required, Validators.maxLength(8)]);
  fontSize = 16;
  length: any;
  pageSize = 10;
  pageSizeOptions = [10, 20, 30, 50, 100];
  formData = {};
  noubaTableDetails = [];
  downloadNoubaData;
  buildingNumberList = [];
  noubaDownloadValues = [];
  options: string[] = [];
  noubaCodeFilteredOptions: string[];
  noNoubaCodeRecords: string = '';
  @ViewChild('noubaCodeInput') noubaCodeInput: ElementRef;
  noubaCodeLength: number = 0;
  bulkDeleteNouba = [];

  constructor(public snackBar: MatSnackBar, private fb: FormBuilder, public dialog: MatDialog,
    private router: Router, private pfepService: PfepService, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.getBuildingNumbers();
    this.getNoubaTableData();
    this.buildingArrLength = this.buildings.value.length;
  }

  getNoubaCodeData(code) {
    this.pfepService.getNoubaCodes(code).subscribe(response => {
      if (response.status && response.status.statusCode === 200) {
        const noubaCodeArray = response.result;
        this.noubaCodeFilteredOptions = noubaCodeArray;
        if (response.result.length === 0) {
          this.noNoubaCodeRecords = 'No Nouba Codes Found';
        }
      }
    });
  }

  getNoubaCodeChar(e) {
    const noubaCodeChar = this.noubaCodeInput.nativeElement.value;
    this.noubaCodeLength = this.noubaCodeInput.nativeElement.value.length;
    if (this.noubaCodeLength > 0) {

      if (noubaCodeChar.includes('*')) {
        this.noubaCodeLength -= 1;
      }
      if(this.noubaCodeLength < 4 && this.noubaCodeLength > 0){
        this.getNoubaCodeData(this.noubaCodeInput.nativeElement.value);
        this.noubaCodeFilteredOptions = this._filter(this.noubaCodeInput.nativeElement.value);
      }
      if(this.noubaCodeLength < 1){
        this.noubaCodeFilteredOptions = [];
        this.noNoubaCodeRecords = '';
      }
    } else {
      this.noubaCodeFilteredOptions = [];
      this.noNoubaCodeRecords = '';
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }


  getBuildingNumbers() {
    this.pfepService.getBuildingData().subscribe(response => {
      const buildingNumberArray = response.result;
      if (response.status && response.status.statusCode === 200) {
        this.buildingNumberList = [...this.buildingNumberList, ...buildingNumberArray];
      }
    });
  }

  getNoubaTableData(type?) {
    const initialObj = {
      'buildingNos': this.buildingsArr,
      'pageNo': 0,
      'pageSize': this.pageSize,
    };
    this.spinner.show();
    this.pfepService.getNoubaData(initialObj).subscribe(response => {
      const noubaData = response.result;
      if (response.status && response.status.statusCode === 200) {
        this.spinner.hide();
        this.length = response.result.totalCount;
        if (type === 'onUpdate') {
          this.dataSource = new MatTableDataSource<NoubaTableData>(response.result.data);
          this.downloadNoubaData = response.result.data;
        } else {
          this.dataSource = new MatTableDataSource<NoubaTableData>(response.result.data);
          this.downloadNoubaData = response.result.data;
        }
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    }, error => {
      this.spinner.hide();
    });
  }

  handleNoubaPage(event, totalData) {
    const searchObj = {
      'buildingNos': this.buildingsArr,
      'code': this.noubaCodeInput.nativeElement.value,
      'pageNo': event.pageIndex,
      'pageSize': event.pageSize,
    };
    this.pageSize = event.pageSize;
    this.pfepService.getNoubaData(searchObj).subscribe(response => {
      const rackData = response.result;
      if (response.status && response.status.statusCode === 200) {
        this.length = response.result.totalCount;
        this.dataSource = new MatTableDataSource<NoubaTableData>(response.result.data);
        this.downloadNoubaData = response.result.data;
      }
    });
  }

  // tslint:disable-next-line: use-life-cycle-interface
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  sortData(event) {
    const searchObj = {
      'orderBy': event.direction,
      'pageNo': 0,
      'pageSize': this.pageSize,
      'sortBy': event.active
    };
this.spinner.show();
    this.pfepService.noubaDataBySearch(searchObj).subscribe(response => {
      if (response && response.status && response.status.statusCode === 200) {
        this.spinner.hide();
        this.length = response.result.totalCount;
        this.dataSource = response.result.data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.downloadNoubaData = response.result.data;
      }
    }, error => {
      this.spinner.hide();
    });
  }
  onBuildingChange(event){
    this.buildingArrLength = this.buildings.value.length;
  }
  searchByBuildingNumber() {
    this.buildingsArr = [...this.buildings.value];
    if(this.buildingsArr.length === 0){
      return;
    }
    const searchObj = {
      'buildingNos': this.buildingsArr,
      'pageNo': 0,
      'pageSize': this.pageSize,
    };
    this.spinner.show();
    this.pfepService.noubaDataBySearch(searchObj).subscribe(response => {
      if (response && response.status && response.status.statusCode === 200) {
        this.spinner.hide();
        this.length = response.result.totalCount;
        this.dataSource = new MatTableDataSource<NoubaTableData>(response.result.data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.downloadNoubaData = response.result.data;
      }
    }, error => {
      this.spinner.hide();
    });
  }
  searchByNoubaCode() {
    if (this.noubaCodeInput.nativeElement.value.length < 1) {
      return;
    }
    const searchObj = {
      'code': this.noubaCodeInput.nativeElement.value,
      'pageNo': 0,
      'pageSize': this.pageSize,
    };
    this.spinner.show();
    this.pfepService.noubaDataBySearch(searchObj).subscribe(response => {
      if (response && response.status && response.status.statusCode === 200) {
        this.spinner.hide();
        this.length = response.result.totalCount;
        this.dataSource = new MatTableDataSource<NoubaTableData>(response.result.data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.downloadNoubaData = response.result.data;
      }
    }, error => {
      this.spinner.hide();
    });
  }
  resetSearch() {
    const searchObj = {
      'pageNo': 0,
      'pageSize': this.pageSize,
    };
    this.spinner.show();
    this.pfepService.noubaDataBySearch(searchObj).subscribe(response => {
      if (response && response.status && response.status.statusCode === 200) {
        this.spinner.hide();
        this.noubaCodeInput.nativeElement.value = '';
        this.noubaCodeFilteredOptions = [];
        this.buildingArrLength = 0;
        this.buildingsArr = [];
        this.noubaCodeLength = 0;
        this.buildings.reset();
        this.noubaCode.reset();
        this.length = response.result.totalCount;
        this.dataSource = response.result.data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.downloadNoubaData = response.result.data;
      }
    });
  }
  onBuildingRemoved(build: any): void {
    const updateBuilding = this.buildings.value as string[];
    this.removeFirst(updateBuilding, build);
    this.buildings.setValue(updateBuilding);
    this.buildingArrLength = this.buildings.value.length;
  }


  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }
  // changeFont(operator) {
  //   operator === '+' ? this.fontSize++ : this.fontSize--;
  //   (this.noubaPage.nativeElement).style.fontSize = `${this.fontSize}px`;
  // }

  onFileChange(event) {
    this.file = event.target.files[0];
    this.openNoubaUploadDialog(this.file);
  }


  openNoubaUploadDialog(file): void {
    // tslint:disable-next-line: prefer-const
    let dialogRef = this.dialog.open(ModalOverviewComponent, {
      width: 'auto',
      disableClose: true,
      data: { type: 'Nouba', file: file }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'updateData') {
        this.getNoubaTableData('onUpdate');
      }
      this.file = null;
      this.noubaInput.nativeElement.value = null;
      dialogRef.close();
    });
  }

  editRow(editedRow) {
    // tslint:disable-next-line: prefer-const
    let dialogRef = this.dialog.open(ModalOverviewComponent, {
      minWidth: 'auto',
      maxWidth: '95vw',
      disableClose: true,
      data: { type: 'EditNouba', noubaData: editedRow }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'updateData') {
        this.getNoubaTableData('onUpdate');
      }
      dialogRef.close();
    });
  }
  goTo() {
    this.router.navigateByUrl('dashboard');
  }
  downloadNoubaCodesTemplate() {
    window.location.assign(environment.noubaUpload_saas);
  }

  downloadNoubaCSV() {
    if (this.buildingsArr.length === 0 &&
       (this.noubaCodeInput.nativeElement.value === null || this.noubaCodeInput.nativeElement.value === ''))  {
      const searchObj = {
        'pageSize': 5000,
      };
      this.pfepService.getNoubaData(searchObj).subscribe(response => {
        this.noubaDownloadValues = response.result.data;
        this.exportNoubaDownloadData(this.noubaDownloadValues);
      });
    } else if (this.buildingsArr.length !== 0) {
      const searchObj = {
        'buildingNos': this.buildingsArr,
        'pageSize': 5000,
      };
      this.pfepService.getNoubaData(searchObj).subscribe(response => {
        if (response && response.status && response.status.statusCode === 200) {
          this.noubaDownloadValues = response.result.data;
          this.exportNoubaDownloadData(this.noubaDownloadValues);
        }
      });
    } else if (this.buildingsArr.length === 0 &&
      (this.noubaCodeInput.nativeElement.value !== null || this.noubaCodeInput.nativeElement.value !== '') ) {
      const searchObj = {
        'code': this.noubaCodeInput.nativeElement.value,
        'pageSize': 5000,
      };
      this.pfepService.getNoubaData(searchObj).subscribe(response => {
        if (response && response.status && response.status.statusCode === 200) {
          this.noubaDownloadValues = response.result.data;
          this.exportNoubaDownloadData(this.noubaDownloadValues);
        }
      });
    }
  }

  exportNoubaDownloadData(data) {
    this.spinner.show();
    let exportNoubaData = [];
    data.forEach(element => {
    let noubaObj = {};
      noubaObj['Nouba Code'] = element.noubaCode;
      noubaObj['Driving Direction'] = element.drivingDirection;
      noubaObj['X'] = element.x;
      noubaObj['Y'] = element.y;
      noubaObj['Depth(X)'] = element.depth;
      noubaObj['Width(Y)'] = element.width;
      noubaObj['BuildingNumber'] = element.building;
      exportNoubaData.push(noubaObj);
    });
    let options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: false,
      headers: ['Nouba Code', 'Driving Direction', 'X', 'Y', 'Depth(X)', 'Width(Y)', 'BuildingNumber']
    };
    // tslint:disable-next-line: no-unused-expression
    new AngularCsv(exportNoubaData, 'Nouba Data', options);
    this.spinner.hide();
  }

  showHistory(noubaHistory) {
    let dialogRef = this.dialog.open(PfepHistoryComponent, {
      minWidth: '95vw',
      disableClose: true,
      data: { type: 'NoubaHistory', noubaHistoryData: noubaHistory }
    });

    dialogRef.afterClosed().subscribe(result => {
        dialogRef.close();
    });
  }
  openAddNouba() {
    let dialogRef = this.dialog.open(AddRackNoubaPopupComponent, {
      minWidth: 'auto',
      maxWidth: '97vw',
      disableClose: true,
      data: { type: 'AddNoubaData'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'updateData') {
        this.getNoubaTableData('onUpdate');
      }
        dialogRef.close();
    });
  }
  deleteNoubaData(noubaCode){
    this.bulkDeleteNouba = [];
    this.bulkDeleteNouba.push(noubaCode);
    let dialogRef = this.dialog.open(AddRackNoubaPopupComponent, {
      width: 'auto',
      disableClose: true,
      data: { type: 'DeleteNoubaData', noubaCode: this.bulkDeleteNouba}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'updateData') {
        this.bulkDeleteNouba = [];
        this.getNoubaTableData('onUpdate');
      }
      this.bulkDeleteNouba = [];
      this.selection.clear();
        dialogRef.close();
    });
  }
  isAllSelected() {
    this.bulkDeleteNouba = [];
    if (this.selection.selected.length) {
      this.selection.selected.forEach(element => {
        this.bulkDeleteNouba.push(element.noubaCode);
      });
    }
    const numSelected = this.selection.selected.length;
    const numRows =  this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.bulkDeleteNouba = [];
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
    if (this.selection.selected.length) {
      this.selection.selected.forEach(element => {
        this.bulkDeleteNouba.push(element.noubaCode);
      });
    }
  }
  deleteBulkData() {
    let dialogRef = this.dialog.open(AddRackNoubaPopupComponent, {
      width: 'auto',
      disableClose: true,
      data: { type: 'DeleteNoubaData', noubaCode: this.bulkDeleteNouba}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'updateData') {
        this.bulkDeleteNouba = [];
        this.getNoubaTableData('onUpdate');
      }
      this.bulkDeleteNouba = [];
      this.selection.clear();
        dialogRef.close();
    });
  }
}
